export default "__VITE_ASSET__85da5514__"